const games = {
  state: [
    {
      id: '1',
      src: require('@/assets/img/lol.png'),
      height: '60px',
      width: '265px',
      contain: true,
    },
    {
      id: '2',
      src: require('@/assets/img/pinpng.com-csgo-logo-png-235434.png'),
      height: '60px',
      width: '265px',
      contain: true,
    },
    {
      id: '3',
      src: require('@/assets/img/dota2.png'),
      height: '60px',
      width: '265px',
      contain: true,
    },
    {
      id: '4',
      src: require('@/assets/img/sports.png'),
      height: '60px',
      width: '265px',
      contain: true,
    },
    //{ id: '2', src: require('@/assets/img/fortnite.png') },
  ],
}
export default games
